import React, { useState } from 'react';
import useFormInput, { UseFormInputParams } from './useFormInput';
import InputPlaceholder from '../InputPlaceholder';
import type { InputPlaceholderProps } from '../InputPlaceholder/InputPlaceholder';
export type FormInputProps<P, V> = {
  component: React.ComponentType<P>;
} & UseFormInputParams<V> & Omit<P, 'setValue' | 'value' | 'onValue'>;
function FormInput<P, V = any>(props: FormInputProps<P, V>): JSX.Element {
  const {
    component: Comp,
    placeholderValue,
    ...compProps
  } = props;
  const formInputProps = useFormInput<V>(props);
  const [replacingPlaceholder, setReplacingPlaceholder] = useState(false);
  const showPlaceholderInput = (formInputProps?.value === null || formInputProps?.value === undefined) && placeholderValue && !replacingPlaceholder;
  if ('fieldPath' in compProps) {
    delete compProps.fieldPath;
  } else if ('fieldMapping' in compProps) {
    delete compProps.fieldMapping;
  }
  if (showPlaceholderInput) {
    return <InputPlaceholder value={placeholderValue as string} onClickEdit={() => setReplacingPlaceholder(true)} {...compProps as unknown as InputPlaceholderProps} />;
  }
  if (Comp) {
    const errors = formInputProps?.errors?.length > 0 && ('errors' in compProps && compProps['errors']?.['length']) > 0 ? formInputProps?.errors.concat(compProps['errors']) : 'errors' in compProps && compProps['errors']?.['length'] > 0 ? compProps['errors'] : formInputProps?.errors;
    return <Comp {...formInputProps} onValue={formInputProps.setValue} {...compProps as unknown as P} errors={errors} />;
  }
  return null;
}
export default FormInput;